module.exports = __webpack_public_path__ + "static/panoram_logo.72045f31.svg";